export enum MarketingEvents {
  CHECKOUT_STARTED = "CHECKOUT_STARTED",
  RISK_APPROVED = "RISK_APPROVED",
  TERMS_AND_CONDITIONS_ACCEPTED = "TERMS_AND_CONDITIONS_ACCEPTED",
}

export default MarketingEvents;
